export default "__VITE_ASSET__DytHWeSB__"